import React from 'react';

function KnowMore1() {
    return (
        <div className="select-none w-full h-full">
            <img data-aos="fade-right" className="hidden lg:block md:block absolute hover:translate-x-1" src="https://i.ibb.co/BTBrmV7/cloud6.png" alt="cloud6" />
            
            <div className="relative px-auto lg:pt-10 h-auto w-auto">
                <h1 className="lg:text-2xl sm:text-3xl md:text-4xl text-xl text-center font-bold text-[#0139B5] tracking-tight ">
                    <span className="block xl:inline underline">Know More</span> </h1>
                <div data-aos="fade-in" className="flex justify-evenly">
                    <div className="pr-30 justify-center">
                        <div className="select-none lg:text-center md:text-left lg:pt-12 md:pt-12 pt-6 lg:tracking-widest lg:leading-10 md:leading-8 lg:pl-10 md:pl-8 pl-6">
                            <span className="lg:text-3xl md:text-2xl text-grey font-bold">Have </span>
                            <span className="lg:text-5xl md:text-4xl text-yellow-500 font-bold">Detailed Knowledge </span>
                            <span className="lg:text-3xl md:text-2xl text-grey font-bold">of </span>
                            <span className="lg:text-5xl md:text-4xl text-red-500 font-bold">Things </span>
                            <span className="lg:text-3xl md:text-2xl text-grey font-bold">that you </span>
                            <span className="lg:text-5xl md:text-4xl text-blue-600 font-bold">Perform</span>
                        </div>
                        <div className="hidden lg:block select-none lg:text-center pt-6 lg:leading-10 px-10">
                            <span className="lg:text-2xl md:text-xl text-grey font-bold">Here you will get </span>
                            <span className="lg:text-3xl md:text-2xl text-red-500 font-bold">Detailed Information </span>
                            <span className="lg:text-2xl md:text-xl text-grey font-bold">of various</span>
                            <span className="lg:text-2xl md:text-xl text-grey font-bold"> activities performed in </span>
                            <span className="lg:text-3xl md:text-2xl text-blue font-bold">Modernvate</span>
                        </div>
                    </div>
                    <img
                        data-aos="fade-left"
                        className="select-none hidden lg:block md:block lg:pr-10 lg:h-auto lg:w-96 md:h-60 md:w-64"
                        src="https://i.ibb.co/ydMyLYC/Girl1.png"
                        alt="Girl Reading Books"
                    />
                </div>
                <div className="select-none lg:mx-14 md:mt-4 md:mx-6 mx-2 mt-10 p-2 bg-slate-100 bg-opacity-40 border-4 border-white/60 lg:rounded-tr-[5rem] lg:rounded-bl-[5rem] md:rounded-tr-[3rem] md:rounded-bl-[3rem]">
                    <div className="flex items-center px-2 rounded-br-3xl shadow-md bg-cyan-200 bg-opacity-30 lg:w-1/2 md:w-1/2 w-3/4">
                        <img
                            className="lg:h-12 lg:w-12 md:h-8 md:w-6 h-4 w-6"
                            src="https://i.ibb.co/bRMZxMw/modernvate.png"
                            alt="ModernVate logo"
                        />
                        <span className="select-none lg:text-2xl md:text-xl text-sm font-extrabold lg:tracking-wider text-redish pl-2">MODERNVATE</span>
                    </div>
                    <div data-aos="fade-left" className="select-none lg:text-xl md:text-sm text-[12px] text-grey lg:p-5 md:p-5 p-2 lg:tracking-wider md:tracking-wider">
                        <span className="text-blue font-bold">Modernvate</span> is an Incubation Digital Platform hosted completely on cloud.
                        It is a one-stop destination for all your professional needs.
                        A website which will provide a platform for young students to showcase their ideas,
                        show their skills, and get tools, to uplift their ideas through guidance of IT industrialists,
                        business people, institutions, and organizations. Modernvate provides infinite services
                        in real world, helps different categories of users such as Businesses, Organizations,
                        Institues, Students, etc. It supports and helps in upskilling knowledge of individuals and also
                        helps in developing practical skills. We're scaling extensively day by day to offer you the best services.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KnowMore1;